import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import { PAGE_LINKS } from '@/helpers/commonConsts'
import adminRoutes from '@/pages/admin/route'
import mobileRoutes from '@/pages/mobile/route'
import pcRoutes from '@/pages/pc/route'

const routes: RouteObject[] = [
  ...mobileRoutes,
  ...adminRoutes,
  ...pcRoutes,
  {
    path: '*',
    element: <Navigate to={PAGE_LINKS.home} replace />,
  },
]

export const Router = () => {
  return useRoutes(routes)
}
